module.exports = __webpack_public_path__ + "img/medal7.3598c6c4.png";